import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import nav from './nav';
import errors from './errors';
import properties from './properties';
import profileProviders from './profileProviders';
import intents from './intents';
import consents from './consents';

Vue.use(Vuex);
Vue.config.debug = true;

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        auth,
        nav,
        errors,
        properties,
        profileProviders,
        intents,
        consents,
    },
    strict: debug,
    plugins: [],
});



// WEBPACK FOOTER //
// ./src/store/index.js